import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import Button from 'components/Common/Button';

export class AccountLanguage extends Component {
  static propTypes = {
    language: PropTypes.string.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = { language: this.props.language };
  }

  handleChange = event => {
    this.setState({ language: event.target.value });
  };

  handleSubmit = event => {
    this.props.onSubmit(this.state.language);
    event.preventDefault();
  };

  render() {
    return (
      <div className="layout__section">
        <h2>{this.props.t('account.language.heading')}</h2>

        <p>{this.props.t('account.language.description')}</p>

        <p className="small small--top-margin-fix">
          {this.props.t('account.language.note')}
        </p>

        <form onSubmit={this.handleSubmit}>
          <label htmlFor="account-language">
            {this.props.t('account.language.label')}
          </label>

          <select
            id="account-language"
            value={this.state.language}
            onChange={this.handleChange}
          >
            <option value="fi">
              {this.props.t('account.language.values.fi')}
            </option>
            <option value="en">
              {this.props.t('account.language.values.en')}
            </option>
          </select>

          <Button
            type="submit"
            isLoading={this.props.isSubmitting}
            disabled={this.state.language === this.props.language}
          >
            {this.props.t(
              `general.${this.props.isSubmitting ? 'updating' : 'update'}`
            )}
          </Button>
        </form>
      </div>
    );
  }
}

export default translate()(AccountLanguage);



// WEBPACK FOOTER //
// ./src/components/AccountLanguage/AccountLanguage.js